import './css/site.scss';
import main from './main';

const renderApp = async () => {
    await main();
};


renderApp().catch((err) => {
    // eslint-disable-next-line no-console
    console.error('App failed to initialize:', err);
});
